export default __webpack_public_path__ + "static/googleEmotion-d6f5663b7b0199bf306d87f79977c297.mp4";